import { styled } from '@nykaa/ui-components';

export const ProgressContainer = styled.div<{
  height: number;
  maxWidth: number;
  backgroundColor: string;
}>`
  width: ${(props) => props.maxWidth}px;
  height: ${(props) => props.height}px;
  border-radius: ${({ theme }) => theme.borders.radius10};
  background-color: ${(props) => props.backgroundColor};
  margin: ${({ theme }) => `0 ${theme.spacing.spacing80} 0 ${theme.spacing.spacing40}`};
`;

export const ProgressContent = styled.div<{
  height: number;
  value: number;
  foregroundColor: string;
}>`
  height: ${(props) => props.height}px;
  border-radius: ${({ theme }) => theme.borders.radius10};
  background-color: ${(props) => props.foregroundColor};
  width: ${(props) => props.value}%;
`;
